import ShortUniqueId from "short-unique-id";
/**
 * Функция округляет координаты точки до заданной точности
 */
export const uid = new ShortUniqueId({ length: 6 });